import { render, staticRenderFns } from "./export-import.component.vue?vue&type=template&id=2a02b338&"
import script from "./export-import.component.vue?vue&type=script&lang=js&"
export * from "./export-import.component.vue?vue&type=script&lang=js&"
import style0 from "./export-import.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports